import getTranslation from 'bdata-sns-shared/utils/getTranslation';
import GameStateTypes from 'bdata-sns-shared/game/types/GameStateTypes';
import getProcessedGameDate from 'bdata-sns-shared/utils/getProcessedGameDate';

export const getVerticalGameStateLabel = (options) => {
    let content = '';
    let subcontent = '';

    const {
        gameState,
        dictionary,
        tz,
        gameNumber,
        gameDate,
        status,
        linescore,
        localTimezone
    } = options;

    const {
        abstract: {
            isDoubleHeader,
            isPreGameDelay,
            isWarmup,
            isInGameDelay,
            isPostponed,
            isSuspended,
            isCancelled,
            isPreview
        } = {}, startTimeTBD = false
    } = status;

    const { currentInning, scheduledInnings, inningState } = linescore || {};
    const game = {
        gameDate,
        gameNumber
    };

    switch (gameState) {
    case GameStateTypes.PREVIEW:
        if (isPreGameDelay) {
            content = `${getTranslation(dictionary, 'game_status_delayed', 'Delay')}`;
        } else {
            content = getProcessedGameDate({
                gameDate,
                tz,
                isPreview,
                startTimeTBD,
                game,
                dictionary,
                isDoubleHeader,
                localTimezone
            });
        }
        return {
            gameBaseLabel: content,
            gameSubLabel: subcontent
        };
    case GameStateTypes.LIVE:
        if (isWarmup) {
            content = getTranslation(dictionary, 'game_status_warmup', 'Warmup');
        } else {
            if (inningState) {
                content = `${getTranslation(dictionary, inningState, inningState)} ${currentInning}`;
            }
            if (isSuspended) {
                subcontent = getTranslation(dictionary, 'game_status_suspended', 'Suspended');
            } else if (isInGameDelay) {
                subcontent = getTranslation(dictionary, 'game_status_delayed', 'Delayed');
            }
        }
        return {
            gameBaseLabel: content,
            gameSubLabel: subcontent
        };
    case GameStateTypes.FINAL:
        if (isCancelled) {
            content = getTranslation(dictionary, 'game_status_cancelled', 'Cancelled');
        } else if (isPostponed) {
            content = getTranslation(dictionary, 'game_status_postponed', 'Postponed');
        } else {
            const extraInningsSuffix = (typeof currentInning !== 'undefined' && typeof scheduledInnings !== 'undefined' && currentInning !== scheduledInnings) ? `/${currentInning}` : '';
            content = `${getTranslation(dictionary, 'game_status_final', 'Final')}${extraInningsSuffix}`;
        }
        return {
            gameBaseLabel: content,
            gameSubLabel: subcontent
        };
    default:
        return {
            gameBaseLabel: content,
            gameSubLabel: subcontent
        };
    }
};
